<template>
  <div>
    <div class="tab-box">
      <div class="tab-item" v-for="(item,index) in tablist" :key="index" @click="tabClick(item.messageType)">
        <span :class="tab == item.messageType ? 'tab-click' : ''">{{item.messageTypeName}}</span>
        <div v-if="item.unreadCount > 0" class="num">{{item.unreadCount}}</div>
        <div v-if="tab == item.messageType" class="tab-l"></div>
      </div>
    </div>
    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <van-cell v-for="(item,index) in list" :key="index">
        <template>
          <router-link :to="'/admin/notice/log-detail/'+ item.id">
            <div class="title">
              <div :style="item.isRead ? 'color: #999' : 'color: #000'">{{item.title}}</div>
              <van-icon name="arrow" color="#333" />
            </div>
            <div class="data">
              <div :class="item.messageType == 1 || item.messageType == 2 ? 'type-1' : item.messageType == 3 ? 'type-2' : 'type-3'">{{item.messageSubTypeTitle}}</div>
              <div class="time">{{ formatDate(item.createTime) }}</div>
            </div>
          </router-link>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import Vue from 'vue';
import {
  Button,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Dialog,
  DropdownItem,
  DropdownMenu,
  Field,
  Icon,
  ImagePreview,
  List,
  Picker,
  Popup,
  Switch,
  Tag,
  Toast
} from 'vant';
import {getMessageNotice,noticeLogList} from "@/api/admin/notice";
import moment from "moment";
import { badge } from '@/main.js';

Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Field)
Vue.use(ImagePreview)
Vue.use(List)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Switch)
Vue.use(Icon)
Vue.use(Tag);
Vue.use(Dialog)
export default {
  name: "log-message",
  props: {},
  components: {},
  computed: {},
  data() {
    return {
      tab: 1,
      queryFormModel: {
        title: null,
        content: null,
      },
      clerkMap: new Map(),
      list: [],
      tablist: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10,
      activeNames: [1]
    }
  },
  methods: {
    tabClick(tab){
      this.tab = tab
      this.onLoad(true)
    },
    formatTime(e) {
      return moment(e).format('YYYY-MM-DD HH:mm')
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    onLoad(resetPage) {
      // 重置为首页
      if (resetPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      noticeLogList(this.tab, this.pageNo, this.pageSize).then(res => {
        this.loading = false;
        const data = res.data;
        if (data.code === 0) {
          this.list = this.list.concat(data.data.list)
          if (data.data.total>this.list.length) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载' + this.$store.state.label.clerkLabel + '失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
    },
    tabLoad() {
      getMessageNotice().then(res => {
        const data = res.data;
        if (data.code === 0) {
          this.tablist = data.data
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })

      badge.$on('badge', () => {
        this.onLoad(true)
        getMessageNotice().then(res => {
          const data = res.data;
          if (data.code === 0) {
            this.tablist = data.data
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      });
    }
  },
  mounted() {
    this.tabLoad()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>
<style lang="less" scoped>
.label {
  color: #999;
  margin-right: 5px;
}
.qrbox {
  display: table;
  margin: 10px auto;
}

.btn-play-audio {
  img {
    height: 20px;
  }
}
.tab-box{
  display: flex;
  align-items: center;
  padding: 15px;
  overflow-x: auto;
  .tab-item{
    position: relative;
    margin-right: 55px;
    white-space: nowrap;
    .num{
      color: #fff;
      font-size: 12px;
      line-height: 12px;
      background: red;
      border-radius: 999px;
      padding: 2px 8px;
      position: absolute;
      top: 50%;
      right: -5px;
      transform: translate(100%,-50%);
    }
    .tab-click{
      color: var(--primary-color);
    }
    .tab-l{
      width: 100%;
      height: 2px;
      border-radius: 999px;
      background: var(--primary-color);
      position: absolute;
      bottom: -5px;
      left: 50%;
      transform: translate(-50%,100%);
    }
  }
}
.title{
  display: flex;
  align-items: center;
  color: #333;
  div{
    flex: 1;
  }
}
.data{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  .type-1{
    color: #85888e;
    font-size: 12px;
    line-height: 12px;
    padding: 6px 12px;
    border: 1px #b8b9bd solid;
    border-radius: 5px;
    background: #f2f2f3;
  }
  .type-2{
    color: #f26161;
    font-size: 12px;
    line-height: 12px;
    padding: 6px 12px;
    border: 1px #f7a4a4 solid;
    border-radius: 5px;
    background: #feeeee;
  }
  .type-3{
    color: #3894ff;
    font-size: 12px;
    line-height: 12px;
    padding: 6px 12px;
    border: 1px #4299ff solid;
    border-radius: 5px;
    background: #fff;
  }
  .time{
    color: #333;
  }
}
</style>
